/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Target_Drop_FrameInputs */



/**
* | output |
* | --- |
* | "Target Drop Frame" |
*
* @param {Target_Drop_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const target_drop_frame = /** @type {((inputs?: Target_Drop_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Target_Drop_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Drop frame cible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ziel-Fallrahmen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Telaio di caduta del bersaglio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Целевой кадр с падением")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marco de caída de objetivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("目标掉帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ターゲットドロップフレーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टारगेट ड्रॉप फ्रेम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Moldura de queda do alvo")
	return /** @type {LocalizedString} */ ("Target Drop Frame")
});